<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [erroremessage]="erroremessage"
  [isShowModal]="false"
  [model]="model"
  [columns]="columns"
  secondClass="main-page"
  (valueChangeByApiName)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <editable-grid
      #grid
      [columns]="InvVoucherDetailList"
      [dataList]="model.InvVoucherDetailList"
      [hideToolber]="true"
      [isAdd]="false"
      [isEdit]="false"
      [isDelete]="false">
    </editable-grid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="CreateVoucher()"
      class="action-btn"
      label="انتقال موجودی"
      size="large"
      [disabled]="!isNewRow"
      appearance="flat">
    </ssg-button>
    <ssg-button
      icon="fa fa-filter"
      buttontype="button"
      (click)="deleteVoucher()"
      class="action-btn"
      label="حذف سند"
      size="medium"
      [disabled]="isNewRow"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
